import { createSelector } from 'reselect'
import { getRouteCompositionIds } from 'models/location/selectors'
import { STATE_FETCHING } from 'constants/stateTypes'

const getById = (state) => state.scenes.byId
export const getSelectedId = (state) => state.scenes.selectedSceneId
export const getFetchState = (state) => state.scenes.fetchState
export const getIsFetching = (state) => getFetchState(state) === STATE_FETCHING

export const getSelectedSceneId = createSelector(
    [getSelectedId, getRouteCompositionIds],
    (id, rIds) => rIds.sceneId || id,
)

export const getSceneItemsById = createSelector([getById], (items) => items)

export const getSceneItems = createSelector([getSceneItemsById], (itemsById) =>
    Object.values(itemsById).sort((a, b) => b.sceneId - a.sceneId),
)

export const getUserSceneItems = createSelector([getSceneItems], (sceneItems) =>
    sceneItems.filter((item) => !item.isStock),
)

export const getStockSceneItems = createSelector([getSceneItems], (stockSceneItems) =>
    stockSceneItems.filter((item) => item.isStock),
)

export const getNumberUserScenes = createSelector([getUserSceneItems], (userScenes) => userScenes.length)

export const getSelectedScene = createSelector(
    [getSceneItemsById, getSelectedSceneId],
    (itemsById, id) => itemsById[id],
)

export const getSelectedSceneWalls = createSelector([getSceneItemsById, getSelectedSceneId], (itemsById, id) => {
    const sceneData = itemsById[id]
    const walls =
        sceneData &&
        sceneData.manifest.plane_orientation_0 &&
        sceneData.manifest.plane_orientation_0.planeData
            .map((plane, idx) => ({
                class: plane.class,
                planeIdx: idx,
            }))
            .filter((plane) => plane.class === 'wall')
    return walls
})

export const getSelectedSceneWallColorsList = createSelector(
    [getSceneItemsById, getSelectedSceneId],
    (itemsById, id) => {
        const sceneData = itemsById[id]
        const colors = sceneData && sceneData.manifest.plane_color_0 && sceneData.manifest.plane_color_0.colors
        return colors && colors.wall
    },
)

export const getSelectedSceneWallMarkers = createSelector([getSceneItemsById, getSelectedSceneId], (itemsById, id) => {
    const sceneData = itemsById[id]
    const colors = sceneData && sceneData.manifest.plane_color_0 && sceneData.manifest.plane_color_0.markers
    return colors
})

export const getHasUserScenes = createSelector([getUserSceneItems], (sceneItems) => sceneItems.length > 0)
